export default __webpack_public_path__ + "static/media/sports_motorsports.2763e60c.svg";